/* eslint-disable no-useless-catch */

export const actionTypes = {
  SET_SELECTED_STORES: 'SET_SELECTED_STORES',
  SET_TITLE: 'SET_TITLE',
}
